<template>
  <v-card
    style="
      position: fixed;
      top: 56%;
      transform: translateY(-56%);
      z-index: 4;
      transition: max-width 0.3s ease-in-out;
      margin-left: -12px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    "
    :style="{ maxWidth: isHovering ? '300px' : '48px' }"
    @mouseover="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <v-list>
      <v-list-item
        v-for="(section, index) in sections"
        :key="index"
        :disabled="!isSectionAvailable(section.anchor)"
        @click="navigate(section.anchor, index)"
        class="pl-3"
      >
        <v-icon :color="index === selectedIndex ? 'primary' : ''">
          {{ section.icon }}
        </v-icon>
        <v-list-item-title
          class="ml-4 body-2"
          :class="{ 'primary--text': index === selectedIndex }"
        >
          {{ section.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      isHovering: false,
      selectedIndex: -1,
      ignoreScroll: false,
      scrollStartPosition: 0,
      sections: [
        {
          text: this.$t("profile.subheader.overview"),
          icon: "mdi-account-details",
          anchor: "profileOverview",
        },
        {
          text: this.$t("profile.subheader.mentorship"),
          icon: "mdi-school",
          anchor: "profileMentorships",
        },
        {
          text: this.$t("profile.subheader.instructions"),
          icon: "mdi-book-open-page-variant",
          anchor: "profileInstructions",
        },
        {
          text: this.$t("profile.subheader.riskAnalyses"),
          icon: "mdi-saw-blade",
          anchor: "profileRiskAnalyses",
        },
        {
          text: this.$t("profile.subheader.extTrainings"),
          icon: "mdi-file-certificate",
          anchor: "profileTrainings",
        },
        {
          text: this.$t("healthCheck.title"),
          icon: "mdi-heart-pulse",
          anchor: "profileHealthCheck",
        },
        {
          text: this.$t("profile.subheader.tools"),
          icon: "mdi-hammer-wrench",
          anchor: "profileTools",
        },
      ],
    };
  },
  methods: {
    isSectionAvailable(anchor) {
      return document.getElementById(anchor) !== null;
    },
    navigate(anchor, index) {
      this.$vuetify.goTo("#" + anchor);
      this.selectedIndex = index;
      this.ignoreScroll = true;
      setTimeout(() => {
        this.ignoreScroll = false;
        this.scrollStartPosition = window.scrollY;
      }, 1000);
    },
  },
  mounted() {
    this.scrollStartPosition = window.scrollY;
    window.addEventListener("scroll", () => {
      if (
        !this.ignoreScroll &&
        Math.abs(window.scrollY - this.scrollStartPosition) > 100
      ) {
        this.selectedIndex = -1;
      }
    });
  },
};
</script>
